/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DispatchAgentResult } from '../../models/dispatch-agent-result';

export interface ApiSessionsTransferAgentsTransferRuleIndexDispatchGet$Params {

/**
 * Ongoing conversation, from the `X-Session-Id` header.
 */
  'X-Session-Id'?: string;

/**
 * Position among that agent's agent-transfer rules, zero-based.
 */
  transferRuleIndex: number;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiSessionsTransferAgentsTransferRuleIndexDispatchGet(http: HttpClient, rootUrl: string, params: ApiSessionsTransferAgentsTransferRuleIndexDispatchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DispatchAgentResult>> {
  const rb = new RequestBuilder(rootUrl, apiSessionsTransferAgentsTransferRuleIndexDispatchGet.PATH, 'get');
  if (params) {
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.path('transferRuleIndex', params.transferRuleIndex, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DispatchAgentResult>;
    })
  );
}

apiSessionsTransferAgentsTransferRuleIndexDispatchGet.PATH = '/api/Sessions/transfer-agents/{transferRuleIndex}/dispatch';
